<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">脱单服务</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>备注：</label>
          <el-input type="text" v-model="remark" placeholder="请输入备注内容" style="width: 16em;" clearable>
            <template #prefix>
              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
            </template>
          </el-input>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="addSingleUrlFun">新建标签</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            border
        >
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" ></el-table-column>
          <el-table-column property="url" label="页面链接" v-if="checkColList.indexOf('页面链接') > -1"></el-table-column>
          <el-table-column property="" label="支付方式" v-if="checkColList.indexOf('支付方式') > -1">
            <template #default="scope">
              {{scope.row.payType == 0?'不限':scope.row.payType == 1?'支付宝':scope.row.payType == 2?'微信':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editServiceDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" class="copy-btn" :data-clipboard-text="scope.row.url" ref="copy" @click="copyFrom" type="primary">复制链接</el-button>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor"></el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getOneToOneUrlPageList, addOrUpdateOneToOneUrl } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import serviceDialog from "./components/serviceDialog";
import Clipboard from "clipboard";
import remarkDialog from "./components/remarkDialog";

export default {
  name: "SingleService",
  components: {  },
  data() {
    return {

      remark: '',

      //刷新组
      colList: ['创建时间', '页面链接', '支付方式', '操作', '备注'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.remark = '';
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['remark'] = this.remark;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getOneToOneUrlPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editServiceDialog(idx, row) {
      Dialog.open({
        title: '服务信息',
        component: serviceDialog,
        data: {
          payType: row.payType,
          id: row.id,
        },
        confirm: (result) => {
            row['payType'] = result.payType
        }
      })
    },

    // updateState(idx, row, state) {
    //   this.pageDataList[idx]['updateLoading'] = true;
    //   let param = {};
    //   param['id'] = row.id;
    //   param['state'] = state;
    //   postFormData(updateSysTagState, param).then((data)=>{
    //     let {code, msg} = data;
    //     if (code == 200) {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'success'
    //       })
    //       this.getPage()
    //     }else {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'warning'
    //       })
    //     }
    //     this.pageDataList[idx]['updateLoading'] = false;
    //   }).catch(()=> {
    //     this.pageDataList[idx]['updateLoading'] = false;
    //   })
    // },

    //复制
    copyFrom(){
      let clipboard = new Clipboard('.copy-btn')
      clipboard.on('success',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制成功',
          type: 'success'
        })
        clipboard.destroy() //使用destroy可以清除缓存
      })
      clipboard.on('error',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制失败',
          type: 'success'
        })
        clipboard.destroy()
      })
    },

    // 添加链接
    addSingleUrlFun() {
      this.$confirm('是否添加新链接？').then(() => {
        let param = {}
        param['id'] = 0
        param['remark'] = ''
        param['url'] = 'https://weixing.h5.yiban1314.com/imitate/one-on-one'
        postFormData(addOrUpdateOneToOneUrl, param).then((data) => {
          if(data.code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: data.msg,
              type: 'success'
            })
            this.getPage();
          } else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: data.msg,
              type: 'warning'
            })
          }
        })
      })
              .catch(() => {})
    },

    toggleSelection(row, column, cell, event) {

      if(column.label == '备注') {
        let serviceForm = Object.assign({}, row);
        Dialog.open({
          title: '更新备注信息',
          component: remarkDialog,
          data: {
            serviceForm: serviceForm,
            width: '400px'
          },
          confirm: (res) => {
            row['remark'] = res.remark
          }
        })
      }
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
